import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Modal, ModalFooter } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { CalloutContext, useOkapiKy } from '@folio/stripes-core';

const propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  categoryId: PropTypes.object,
  isEmpty: PropTypes.bool,
  refetch: PropTypes.func,
};

function DeleteCategoryModal({ onClose, open, categoryId, isEmpty, refetch }) {
  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);

  console.log('isEmpty: ', isEmpty);
  const onDelete = () => {
    if (isEmpty) {
      okapiKy
        .delete(`customField-category/${categoryId}`, {
          timeout: 30000,
          method: 'delete',
          headers: {
            'content-Type': 'application/json',
            accept: 'text/plain',
          },
        })
        .json()
        .then(() => {
          const message = (
            <FormattedMessage
              id="ui-plugin-inventory-templates.deleteCategoryModal.callout.deleted"
              defaultMessage="Custom fields category deleted successfully"
            />
          );
          context.sendCallout({ message, type: 'success' });
          onClose();
          refetch();
        })
        .catch(async (err) => {
          const res = err.response;
          const text = await res.text();
          context.sendCallout({ message: text, type: 'error' });
        });
    } else {
      const message = (
        <FormattedMessage
          id="ui-plugin-inventory-templates.deleteCategoryModal.callout.notEmptyCategory"
          defaultMessage="You cannot delete non-empty category."
        />
      );
      context.sendCallout({ message, type: 'error' });
      onClose();
    }
  };
  const renderFooter = () => {
    return (
      <ModalFooter>
        <Button
          id="delete-custom-fields-category-modal-btn"
          buttonStyle="primary"
          onClick={() => onDelete()}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.deleteCategoryModal.buttons.delete"
            defaultMessage="Delete"
          />
        </Button>
        <Button
          id="delete-custom-fields-category-modal-cancel-btn"
          onClick={onClose}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  return (
    <Modal
      id="delete-custom-fields-category-modal"
      open={open}
      onClose={onClose}
      footer={renderFooter()}
      label={
        <Icon icon="plus-sign" size="large">
          <FormattedMessage
            id="ui-plugin-inventory-templates.deleteCategoryModal.label"
            defaultMessage="Delete Custom fields category"
          />
        </Icon>
      }
      dismissible
    >
      <strong>
        <FormattedMessage
          id="ui-plugin-inventory-templates.deleteCategoryModal.msg"
          defaultMessage="Are you sure to delete the custom fields category?"
        />
      </strong>
    </Modal>
  );
}

DeleteCategoryModal.propTypes = propTypes;
export default DeleteCategoryModal;
